export const isUserLogged = (): boolean => {
  if (localStorage.getItem('AccessToken') !== null) return true;
  return false;
};

export const getNameInitials = (name: string) => {
  return name[0].toUpperCase();
};
